import { AdaptiveDpr, AdaptiveEvents, PerformanceMonitor } from "@react-three/drei";
import { useMemo, useRef } from "react";
import { usePerformanceSettings } from "../src/stores/usePerformanceSettings";

const HALF_RESOLUTION_DPR = 0.5;

const DPR_PRESETS = {
  high: { minDpr: HALF_RESOLUTION_DPR, maxDpr: HALF_RESOLUTION_DPR },
  medium: { minDpr: HALF_RESOLUTION_DPR, maxDpr: HALF_RESOLUTION_DPR },
  low: { minDpr: HALF_RESOLUTION_DPR, maxDpr: HALF_RESOLUTION_DPR },
};

const scoreToTier = (score) => {
  if (score <= 0) return "high";
  if (score === 1) return "medium";
  return "low";
};

export default function PerformanceTuner({ auto = true }) {
  const setTier = usePerformanceSettings((state) => state.setTier);
  const tier = usePerformanceSettings((state) => state.tier);
  const stabilityScoreRef = useRef(0);

  const activePreset = useMemo(() => DPR_PRESETS[tier] ?? DPR_PRESETS.high, [tier]);

  return (
    <>
      <AdaptiveDpr
        pixelated
        minDpr={activePreset.minDpr}
        maxDpr={activePreset.maxDpr}
      />
      <AdaptiveEvents />
      {auto && (
        <PerformanceMonitor
          onDecline={() => {
            stabilityScoreRef.current = Math.min(stabilityScoreRef.current + 1, 2);
            setTier(scoreToTier(stabilityScoreRef.current));
          }}
          onIncline={() => {
            stabilityScoreRef.current = Math.max(stabilityScoreRef.current - 1, 0);
            setTier(scoreToTier(stabilityScoreRef.current));
          }}
        />
      )}
    </>
  );
}
